import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const UserDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>User Detail</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default UserDetailHeader;
